import {
  LOAD_DATA_FAILURE,
  SET_CUSTOMER_FB_POSTS,
  SET_CUSTOMER_FB_POSTS_REQUEST,
  SET_COMMENTS_REQUEST,
  SET_COMMENTS
} from '../actionTypes';

const initialState = {
  customersFbPosts: [],
  totalPages: 0,
  loadingMoreCustomersFbPosts: false,
  comments: [],
  concatComments: false,
  totalCommentsPages: 0,
  loadingMoreComments: false,
  unreadInstagramComments: 0,
  unreadFacebookComments: 0,
  unreadChats: false,
  createCommentNoteFb: false,
  customerFbPostSelected: {},
  agents: [],
  agent_list: [],
  disabledChatOption: false,
  currentCustomerFbPostId: null
}

const commentsReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_CUSTOMER_FB_POSTS:
      return {
        ...state,
        customersFbPosts: action.data.customer_fb_posts,
        totalPages: action.data.total_pages,
        loadingMoreCustomersFbPosts: false,
        agents: action.data.agents,
        storageId: action.data.storage_id,
        agent_list: action.data.agent_list,
        filter_tags: action.data.filter_tags
      };
    case 'EMPTY_COMMENTS':
      return {
        ...state,
        comments: []
      };
    case SET_COMMENTS:
      if (state.currentCustomerFbPostId != action.data?.comments[0]?.customer_fb_post_id) {
        return { ...state, loadingMoreComments: false };
      }

      return {
        ...state,
        comments: action.data.comments,
        totalCommentsPages: action.data.total_pages,
        loadingMoreComments: false,
        agents: action.data.agents,
        storageId: action.data.storage_id,
        agent_list: action.data.agent_list,
        filter_tags: action.data.filter_tags
      };
    case 'SET_UNREAD_INSTAGRAM_COMMENTS':
      return {
        ...state,
        unreadInstagramComments: Number.isInteger(action.data.unread_instagram_comments) ? action.data.unread_instagram_comments : state.unreadInstagramComments,
        unreadChats: Number.isInteger(action.data.unread_chats) ? action.data.unread_chats : state.unreadChats
      };
    case 'SET_UNREAD_FACEBOOK_COMMENTS':
      return {
        ...state,
        unreadFacebookComments: Number.isInteger(action.data.unread_facebook_comments) ? action.data.unread_facebook_comments : state.unreadFacebookComments,
        unreadChats: Number.isInteger(action.data.unread_chats) ? action.data.unread_chats : state.unreadChats
      };
    case 'SET_UNREAD_COMMENTS':
      return {
        ...state,
        unreadInstagramComments: Number.isInteger(action.data.unread_instagram_comments) ? action.data.unread_instagram_comments : state.unreadInstagramComments,
        unreadFacebookComments: Number.isInteger(action.data.unread_facebook_comments) ? action.data.unread_facebook_comments : state.unreadFacebookComments,
        unreadChats: Number.isInteger(action.data.unread_chats) ? action.data.unread_chats : state.unreadChats
      };
    case 'SET_CREATE_COMMENT_NOTE':
      return {
        ...state,
        createCommentNote: action.data.openModal
      };
    case SET_CUSTOMER_FB_POSTS_REQUEST:
      return {
        ...state,
        loadingMoreCustomersFbPosts: true
      };
    case LOAD_DATA_FAILURE:
      return {
        ...state,
        loadingMoreCustomersFbPosts: false
      };
    case 'SET_CUSTOMER_FB_POST_SELECTED':
      return {
        ...state,
        customerFbPostSelected: action.data.customerFbPost
      };
    case 'REMOVE_CUSTOMER_FB_POST_SELECTED':
      return {
        ...state,
        customerFbPostSelected: {}
      };
    case 'SET_LAST_COMMENTS':
      if (state.currentCustomerFbPostId != action.data?.comments[0]?.customer_fb_post_id) return { ...state };

      return {
        ...state,
        comments: action.data.comments,
        totalCommentsPages: action.data.total_pages
      };
    case 'DISABLE_CHAT_OPTIONS':
      return {
        ...state,
        disabledChatOption: action.data.status
      }
    case 'SET_CURRENT_CUSTOMER_FB_POST_ID':
      return {
        ...state,
        currentCustomerFbPostId: action.data.id
      }
    default:
      return state;
    }
  };

export default commentsReducer;
